export enum Localization {
    RU = "ru",
    EN = "en"
}